import React from 'react';
import { Navbar, Image } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';
import { NavItem } from 'react-bootstrap';
import { NavDropdown } from 'react-bootstrap';
import { MenuItem } from 'react-bootstrap';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router';

import './AppNavbar.css';
import logo from '../../assets/images/app_logo.png';

export class AppNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderDropdownTitle(icon, title) {
    return (
      <span>
        <i className={icon} /><span className='menu-text'>{title}</span>
      </span>
    );
  }

  isNavItemActive(name) {
    return this.props.history.location.pathname === name;
  }

  shouldDropDownOpen(name) {
    return this.props.history.location.pathname.indexOf(name) !== -1;
  }

  navigate(path) {
    this.resetMenuOpen();
    this.props.history.push(path);
  }

  navigateDropDown(path, forceOpen = 1) {
    this._forceOpen = forceOpen;
    this.props.history.push(path);
  }

  resetMenuOpen() {
    const resetState = Object.keys(this.state).reduce((state, key) => ({...state, [key]: false}), {});
    this.setState(resetState);
  }

  dropdownToggle(prefix, isOpen, source) {
    if (source === 'rootClose') {
      return;
    }

    if (this._forceOpen > 0) {
      this.resetMenuOpen();
      this.setState({ [`${prefix}menuOpen`]: true });
      this._forceOpen = this._forceOpen - 1;
    } else {
      this.setState({ [`${prefix}menuOpen`]: isOpen });
      // FIXME: Interim solution for cannot collapse a/c menu if child opened
      if (prefix === 'ac' && isOpen === false) {
        this.setState({
          'ac-packagemenuOpen': false,
          'ac-centralmenuOpen': false,
        });
      }
    }
  }

  isMenuOpen(prefixes) {
    if (!Array.isArray(prefixes)) {
      prefixes = [prefixes];
    }
    return prefixes.map(prefix => this.state[`${prefix}menuOpen`]).some(isOpen => isOpen);
  }

  render() {
    const { t } = this.props;
    return (
      <Navbar
        className={
          'navbar navbar-default navbar-fixed-top col-sm-3 col-md-2' +
          (this.props.isShow ? '' : ' hide')
        }
      >
        <Navbar.Header>
          <Navbar.Brand>
            <Image style={{ objectFit: 'contain', padding: 6 }} src={logo} />
          </Navbar.Brand>
          <Navbar.Toggle
            data-toggle="collapse"
            data-target="#main-navigation"
          />
        </Navbar.Header>
        <Navbar.Collapse id="main-navigation">
          <Nav className="nav nav-pills nav-stacked">
            <NavItem
              eventKey={1}
              active={this.isNavItemActive('/dashboard')}
              onClick={() => this.navigate('/dashboard')}
            >
              <i className="fas fa-tachometer-alt" /><span className="menu-text">{t('dashboard')}</span>
            </NavItem>
            <NavItem
              eventKey={2}
              active={this.isNavItemActive('/projects')}
              onClick={() => this.navigate('/projects')}
            >
              <i className="fas fa-folder" /><span className="menu-text">{t('projects')}</span>
            </NavItem>
            <li role="separator" className="divider">
              {t('master information')}
            </li>
            {this.renderMaterials()}
            {this.renderComponents()}
            {this.renderLighting()}
            {this.renderAC()}
            {this.renderHotWater()}
            {this.renderRenewableEnergy()}
            <NavItem
              id="side-menu-other-equipments"
              eventKey={9}
              active={this.isNavItemActive('/other_equipments')}
              onClick={() => this.navigate('/other_equipments')}
            >
              <i className="fas fa-bolt" /><span className="menu-text">{t('other equipments')}</span>
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }

  renderHotWater() {
    const { t } = this.props;
    const prefix = 'hw';
    return (
      <NavDropdown
        eventKey={7}
        open={this.isMenuOpen(prefix)}
        defaultOpen={this.shouldDropDownOpen('/hot_water_system/')}
        title={this.renderDropdownTitle('fas fa-thermometer-half', t('hot water equipment'))}
        id="hot-water-system-dropdown"
        onToggle={(isOpen, event, { source }) => this.dropdownToggle(prefix, isOpen, source)}
      >
        <MenuItem
          eventKey={7.1}
          id="side-menu-hot-water-system-boiler"
          active={this.isNavItemActive('/hot_water_system/boiler')}
          onClick={() => this.navigateDropDown('/hot_water_system/boiler')}
        >
          {t('boiler')}
        </MenuItem>
        <MenuItem
          eventKey={7.2}
          id="side-menu-hot-water-system-heat-pump"
          active={this.isNavItemActive('/hot_water_system/heat_pump')}
          onClick={() => this.navigateDropDown('/hot_water_system/heat_pump')}
        >
          {t('heat pump')}
        </MenuItem>
      </NavDropdown>
    );
  }

  renderAC() {
    const { t } = this.props;
    const prefix = 'ac';
    return (
      <NavDropdown
        eventKey={6}
        open={this.isMenuOpen([prefix, 'ac-package', 'ac-central'])}
        defaultOpen={this.shouldDropDownOpen('/ac/')}
        title={this.renderDropdownTitle('fas fa-snowflake', t('air conditioning'))}
        id="air-conditioning"
        onToggle={(isOpen, event, { source }) => this.dropdownToggle(prefix, isOpen, source)}
      >
        <MenuItem
          eventKey={6.1}
          active={this.isNavItemActive('/ac/split_type')}
          onClick={() => this.navigateDropDown('/ac/split_type')}
        >
          {t('split type')}
        </MenuItem>
        {this.renderACPackage()}
        {this.renderACCentral()}
      </NavDropdown>
    );
  }

  renderACPackage() {
    const { t } = this.props;
    const prefix = 'ac-package';
    return (
      <NavDropdown
        eventKey={6.2}
        open={this.isMenuOpen(prefix)}
        defaultOpen={this.shouldDropDownOpen('/ac/packaged')}
        title={t('ac package menu')}
        id="air-conditioning-package"
        onToggle={(isOpen, event, { source }) => this.dropdownToggle(prefix, isOpen, source)}
      >
        <MenuItem
          eventKey={6.21}
          active={this.isNavItemActive('/ac/packaged_unit')}
          onClick={() => this.navigateDropDown('/ac/packaged_unit', 2)}
        >
          {t('packaged unit')}
        </MenuItem>
        <MenuItem
          eventKey={6.22}
          active={this.isNavItemActive('/ac/packaged/packaged_sub')}
          onClick={() => this.navigateDropDown('/ac/packaged/packaged_sub', 2)}
        >
          {t('packaged sub')}
        </MenuItem>
      </NavDropdown>
    );
  }

  renderACCentral() {
    const { t } = this.props;
    const prefix = 'ac-central';
    return (
      <NavDropdown
        eventKey={6.3}
        open={this.isMenuOpen(prefix)}
        defaultOpen={this.shouldDropDownOpen('/ac/central')}
        title={t('ac central menu')}
        id="air-conditioning-central"
        onToggle={(isOpen, event, { source }) => this.dropdownToggle(prefix, isOpen, source)}>
        <MenuItem
          eventKey={6.31}
          active={this.isNavItemActive('/ac/central')}
          onClick={() => this.navigateDropDown('/ac/central', 2)}
        >
          {t('central unit')}
        </MenuItem>
        <MenuItem
          eventKey={6.32}
          active={this.isNavItemActive('/ac/central/chiller')}
          onClick={() => this.navigateDropDown('/ac/central/chiller', 2)}
        >
          {t('chiller')}
        </MenuItem>
        <MenuItem
          eventKey={6.33}
          active={this.isNavItemActive('/ac/central/water_pump')}
          onClick={() => this.navigateDropDown('/ac/central/water_pump', 2)}
        >
          {t('water pump')}
        </MenuItem>
        <MenuItem
          eventKey={6.34}
          active={this.isNavItemActive('/ac/central/cooling_tower')}
          onClick={() => this.navigateDropDown('/ac/central/cooling_tower', 2)}
        >
          {t('cooling tower')}
        </MenuItem>
        <MenuItem
          eventKey={6.35}
          active={this.isNavItemActive('/ac/central/air_handling_unit')}
          onClick={() => this.navigateDropDown('/ac/central/air_handling_unit', 2)}
        >
          {t('air handling unit')}
        </MenuItem>
      </NavDropdown>
    );
  }

  renderLighting() {
    const { t } = this.props;
    const prefix = 'lt';
    return (
      <NavDropdown
        eventKey={5}
        open={this.isMenuOpen(prefix)}
        defaultOpen={this.shouldDropDownOpen('/lighting/')}
        title={this.renderDropdownTitle('fas fa-lightbulb', t('lighting system'))}
        id="lighting-system-dropdown"
        onToggle={(isOpen, event, { source }) => this.dropdownToggle(prefix, isOpen, source)}
      >
        <MenuItem
          eventKey={5.1}
          active={this.isNavItemActive('/lighting/luminaire')}
          onClick={() => this.navigateDropDown('/lighting/luminaire')}
        >
          {t('luminaire')}
        </MenuItem>
        <MenuItem
          eventKey={5.2}
          active={this.isNavItemActive('/lighting/ballast')}
          onClick={() => this.navigateDropDown('/lighting/ballast')}
        >
          {t('ballast')}
        </MenuItem>
        <MenuItem
          eventKey={5.3}
          active={this.isNavItemActive('/lighting/lighting_set')}
          onClick={() => this.navigateDropDown('/lighting/lighting_set')}
        >
          {t('lighting set')}
        </MenuItem>
      </NavDropdown>
    );
  }

  renderComponents() {
    const { t } = this.props;
    const prefix = 'cm';
    return (
      <NavDropdown
        eventKey={4}
        open={this.isMenuOpen(prefix)}
        defaultOpen={this.shouldDropDownOpen('/components/')}
        title={this.renderDropdownTitle('fas fa-box', t('components'))}
        id="main-nav-dropdown-component"
        onToggle={(isOpen, event, { source }) => this.dropdownToggle(prefix, isOpen, source)}
      >
        <MenuItem
          eventKey={4.2}
          active={this.isNavItemActive('/components/opaque')}
          onClick={() => this.navigateDropDown('/components/opaque')}
        >
          {t('opaque component')}
        </MenuItem>
        <MenuItem
          eventKey={4.1}
          active={this.isNavItemActive('/components/transparent')}
          onClick={() => this.navigateDropDown('/components/transparent')}
        >
          {t('transparent component')}
        </MenuItem>
      </NavDropdown>
    );
  }

  renderMaterials() {
    const { t } = this.props;
    const prefix = 'mt';
    return (
      <NavDropdown
        eventKey={3}
        open={this.isMenuOpen(prefix)}
        defaultOpen={this.shouldDropDownOpen('/materials/')}
        title={this.renderDropdownTitle('fas fa-box', t('materials'))}
        id="main-nav-dropdown-material"
        onToggle={(isOpen, event, { source }) => this.dropdownToggle(prefix, isOpen, source)}
      >
        <MenuItem
          eventKey={3.2}
          active={this.isNavItemActive('/materials/opaque')}
          onClick={() => this.navigateDropDown('/materials/opaque')}
        >
          {t('opaque material')}
        </MenuItem>
        <MenuItem
          eventKey={3.1}
          active={this.isNavItemActive('/materials/transparent')}
          onClick={() => this.navigateDropDown('/materials/transparent')}
        >
          {t('transparent material')}
        </MenuItem>
      </NavDropdown>
    );
  }

  renderRenewableEnergy() {
    const { t } = this.props;
    const prefix = 're';
    return (
      <NavDropdown
        eventKey={8}
        open={this.isMenuOpen(prefix)}
        defaultOpen={this.shouldDropDownOpen('/renewable_energy/')}
        title={this.renderDropdownTitle('fas fa-recycle', t('renewable energy'))}
        id="renewable-energy-dropdown"
        onToggle={(isOpen, event, { source }) => this.dropdownToggle(prefix, isOpen, source)}
      >
        <MenuItem
          id="side-menu-solar-energy"
          eventKey={8.1}
          active={this.isNavItemActive('/renewable_energy/solar_energy')}
          onClick={() => this.navigate('/renewable_energy/solar_energy')}
        >
          {t('solar energy')}
        </MenuItem>
        <MenuItem
          id="side-menu-heat-to-electrical-energy"
          eventKey={8.2}
          active={this.isNavItemActive('/renewable_energy/heat_to_electrical_energy')}
          onClick={() => this.navigateDropDown('/renewable_energy/heat_to_electrical_energy')}
        >
          {t('heat to electrical energy')}
        </MenuItem>
        <MenuItem
          id="side-menu-other-renewable-energy"
          eventKey={8.3}
          active={this.isNavItemActive('/renewable_energy/other_renewable_energy')}
          onClick={() => this.navigateDropDown('/renewable_energy/other_renewable_energy')}
        >
          {t('other renewable energy')}
        </MenuItem>
      </NavDropdown>
    );
  }
}

export default translate('translations')(
  withRouter(props => <AppNavbar {...props} />),
);



// WEBPACK FOOTER //
// ./src/components/appnavbar/AppNavbar.js